import Features from "./features/Features";
import Footer from "./footer/Footer";
import Header from "./header/Header";
import Hero from "./hero/Hero";
import Pricing from "./pricing/Pricing";
import VerticalSpacer from "./shared/VerticalSpacer";

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <section id="homeSection">
        <Header />
        <Hero />
      </section>
      <Features />
      <VerticalSpacer />
      <Pricing />
      <VerticalSpacer />
      <Footer />
    </div>
  );
};

export default Home;
